import _ from 'underscore';
import classNames from 'classnames';
import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { HiddenDivForAnnounce } from '../hidden-div-for-announce';
import { ExamplePromptList } from './example-prompt';

export const ExampleImageListWithoutStyle = ({
  onSelectImage,
  classes,
  MultiLineEllipsisText,
  ExampleImageCell,
  i18n,
  labelId,
}) => {
  const [announcedText, setAnnouncedText] = useState('');
  const promptList = useMemo(() => ExamplePromptList.map(x => ({
    ...x,
    promptText: i18n.getString(x.promptText),
  })), [i18n]);

  const wrappedOnSelectImage = useCallback((promptText, index) => {
    onSelectImage(promptText, index);
    setAnnouncedText(i18n.getString(_TL_('Set the prompt to {{promptText}}'), { promptText }));
  }, [onSelectImage, i18n]);

  return (
    <div className={classNames('example-image-list', classes.exampleImageList)} aria-labelledby={labelId} role="group">
      {_.map(promptList, (template, index) => (
        <ExampleImageCell
          key={`cell-${index}`}
          backgroundImageUrl={template.backgroundImageUrl}
          promptText={template.promptText}
          index={index}
          onSelectImage={wrappedOnSelectImage}
          MultiLineEllipsisText={MultiLineEllipsisText}
        />
      ))}
      <HiddenDivForAnnounce toAnnounce={announcedText} />
    </div>);
};

ExampleImageListWithoutStyle.propTypes = {
  onSelectImage: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    exampleImageList: PropTypes.string,
  }),
  labelId: PropTypes.string,
};

ExampleImageListWithoutStyle.defaultProps = {
  classes: {},
  labelId: '',
};

